import './App.css';
import bannerfuturelink from './FL.png'
import iconlink from './link.svg'
import javascripticon from './Javascript.svg'
import reacticon from './React.svg'
import nodeicon from './nodejs.svg'
import mysqlicon from './mysql.svg'
import stticon from './stt.svg'
import kotlinicon from './kotlin.svg'
import swifticon from './swift.svg'
import ipricon from './ipr.svg'
import codeicon from './code.svg'
import dockericon from './docker.svg'
import phpicon from './php.svg'
import javaicon from './java.svg'
import laravelicon from './laravel.svg'
import ttsicon from './tts.svg'
import mongodbicon from './mongodb.svg'
import bannerinfidea from './infidea.png'
import banneraci from './acitelkom.png'
import bannermtf from './mtfmandiri.png'
import bannerjardinx from './jardinxlp.png'
import bannerindi from './indi.png'
import bannermilkyverse from './milkyverse.png'
import { Link } from 'react-router-dom'

function WebAppDevelopment() {
  return (
<body className='Background' >

    <div className="Navbar">
      <Link to="/artificial-intelligence" className="nav-link">Artificial Intelligence</Link>
      <Link to="/web-app-development" className="nav-link">Web & App Development</Link>
      <Link to="/blockchain" className="nav-link">Blockchain</Link>
    </div>
    
    <p className='Title' >Projects I’ve Worked on</p>

    <div className='Card'>
      <div className='Container'>
        <div className='Content1'>
          <p className='Judul'>Future Link</p>
          <p className='Deskripsi'>
          Sebuah aplikasi berbasis mobile yang dikembangkan untuk menganalisa kepribadian menggunakan sidik jari. Memanfaatkan technology AI dan terintegrasi dengan payment gateway seperti midtrans.
          </p>
          <img className='Banner' src={bannerfuturelink} alt='FL' ></img>
        </div>
        <div className='Content'>
          <p  className='Judul-2'>Worked on</p>
          <div className='Category'>
            <button className='Button-Category'>Website</button>
            <button className='Button-Category'>Mobile App</button>
          </div>
          <p className='Judul-2'>Technologies I have used</p>

          <div className='Category2'>
            <button className='Button-Tech'>
              <img className='icon' src={kotlinicon} alt='kotlin'></img>
              <p>Kotlin</p>
            </button>
            <button className='Button-Tech'>
              <img className='icon' src={reacticon} alt='React'></img>
              <p>React JS</p>
            </button>
            <button className='Button-Tech'>
              <img className='icon' src={swifticon} alt='swift'></img>
              <p>Swift</p>
            </button>
          </div>
          <div className='Category2'>
            <button className='Button-Tech'>
              <img className='icon' src={nodeicon} alt='nodejs'></img>
              <p>NodeJS</p>
            </button>
            <button className='Button-Tech'>
              <img className='icon' src={ipricon} alt='ipr'></img>
              <p>Image Pattern Recognition</p>
            </button>
            <button className='Button-Tech'>
              <p>Flask</p>
            </button>
          </div>
          <a href="https://futurelink.id/" className="Link" target="_blank" rel="noopener noreferrer">
            <img className="icon" src={iconlink} alt="link" />
            <p>Go to Future Link</p>
          </a>
        </div>
      </div>
    </div>

    <div className='Card2'>
      <div className='Container'>
        <div className='Content1'>
          <p className='Judul'>Infidea</p>
          <p className='Deskripsi'>
          Sebuah platform yang berisi bermacam-macam kapabilitas AI. Web tersebut dikembangkan dengan tujuan untuk mendesentralisasikan kapabilitas AI dan dapat digunakan secara langsung oleh pengguna sehingga pengguna mudah memahami.
          </p>
          <img className='Banner' src={bannerinfidea} alt='inifidea' ></img>
        </div>
        <div className='Content'>
          <p  className='Judul-2'>Worked on</p>
          <div className='Category'>
            <button className='Button-Category'>Website</button>
          </div>
          <p className='Judul-2'>Technologies I have used</p>
          <div className='Category2'>
            <button className='Button-Tech'>
              <img className='icon' src={javascripticon} alt='Javascript'></img>
              <p>JavaScript</p>
              </button>
            <button className='Button-Tech'>
              <img className='icon' src={reacticon} alt='React'></img>
              <p>React JS</p>
              </button>
          </div>
          <a href="https://infidea.id/" className="Link" target="_blank" rel="noopener noreferrer">
            <img className="icon" src={iconlink} alt="link" />
            <p>Go to Infidea</p>
          </a>
        </div>
      </div>
    </div>

    <div className='Card4'>
      <div className='Container'>
        <div className='Content1'>
          <p className='Judul'>MTF</p>
          <p className='Deskripsi'>
          Meningkatkan website resmi MTF dalam berbagai sisi seperti source code dengan versi terupdate, masalah security issue yang ditemukan, desain UI/UX, dan menambahkan Fitur Dual Language (Bahasa Indonesia & Bahasa Inggris) pada website MTF.          </p>
          <img className='Banner' src={bannermtf} alt='mandirimtf' ></img>
        </div>       
        <div className='Content'>
          <p  className='Judul-2'>Worked on</p>
          <div className='Category'>
            <button className='Button-Category'>Website</button>
          </div>
          <p className='Judul-2'>Technologies I have used</p>
          <div className='Category2'>
            <button className='Button-Tech'>
              <img className='icon' src={codeicon} alt='code'></img>
              <p>Codeigniter 3</p>
            </button>
            <button className='Button-Tech'>
              <img className='icon' src={mysqlicon} alt='mysql'></img>
              <p>MySQL 8.0</p>
            </button>
            <button className='Button-Tech'>
              <img className='icon' src={dockericon} alt='docker'></img>
              <p>Docker</p>
            </button>
          </div>
          <div className='Category2'>
            <button className='Button-Tech'>
              <img className='icon' src={phpicon} alt='php'></img>
              <p>PHP 8.0</p>
            </button>
          </div>
          <a href="https://www.mtf.co.id/" className="Link" target="_blank" rel="noopener noreferrer">
            <img className="icon" src={iconlink} alt="link" />
            <p>Go to MTF</p>
          </a>
        </div>
      </div>
    </div>

    <div className='Card6'>
      <div className='Container'>
        <div className='Content1'>
          <p className='Judul'>Indi Smart Speaker</p>
          <p className='Deskripsi'>
          Solusi aplikasi yang dapat menerima input suara, kemudian menjalankan perintah atau merespons sesuai dengan suara yang diterima.
          </p>          
          <img className='Banner' src={bannerindi} alt='indi' ></img>
        </div>          
        <div className='Content'>
          <p  className='Judul-2'>Worked on</p>
          <div className='Category'>
            <button className='Button-Category'>Mobile App</button>
          </div>
          <p className='Judul-2'>Technologies I have used</p>
          <div className='Category2'>
            <button className='Button-Tech'>
              <img className='icon' src={javaicon} alt='java'></img>
              <p>Java</p>
            </button>
            <button className='Button-Tech'>
              <img className='icon' src={laravelicon} alt='laravel'></img>
              <p>Laravel</p>
            </button>
            <button className='Button-Tech'>
              <img className='icon' src={stticon} alt='stt'></img>
              <p>Speech to Text</p>
            </button>
          </div>
          <div className='Category2'>
            <button className='Button-Tech'>
              <img className='icon' src={ttsicon} alt='tts'></img>
              <p>Text to Speech</p>
            </button>
            <button className='Button-Tech'>
              <img className='icon' src={reacticon} alt='React'></img>
              <p>React JS</p>
            </button>
            <button className='Button-Tech'>
              <img className='icon' src={mongodbicon} alt='mongodb'></img>
              <p>MongoDB</p>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div className='footer'>
      <a href="https://infidea.id/" className="namefooter" target="_blank" rel="noopener noreferrer">
        <p>2025 Copyright © infidea</p>
      </a>
    </div>
</body>
);
  

  
}

export default WebAppDevelopment;
